import angular from 'angular'
const app = angular.module('AccountingBoxApp');
const templates = require.context("./", true, /.*\.html$/);

app.run(function($templateCache) {
    templates.keys().forEach(template => {
        $templateCache.put(template.replace("./", "app/"), templates(template));
    });
});
